// extracted by mini-css-extract-plugin
export default {"container":"Review_container__kEKGV","button-wrapper":"Review_button-wrapper__aRRV9"};